
export enum LoginState {
    NotLoggedIn = 0,                // user has not been authenticated
    LoggedInBootstrapComplete = 1,  // user has been authenticated and bootstraped
    LoggedInNeedBootstrap = 2       // user has been authenticated, but needs to bootstrap on next navigation
}

export interface LoginViewState {
    loginState: LoginState;
}